import $ from 'jquery';
//import _ from 'underscore';
import {setElementsFromScope, formatAddress} from "../../../utilities/selectorHelpers";
/*import PalletShippingView from "../ContentsTab/PalletShippingView";
import ParcelShippingView from "../ContentsTab/ParcelShippingView";*/
import AsnStore from "../../../stores/AsnStore";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import ServicesTab from "../ServicesTab/ServicesTab";
import ShippingReviewView from "./ShippingReviewView";
import PackingReviewView from "./PackingReviewView";

const elementsMap = {
  sectionTitlesReviewTab: ".section-step-title-inner",

  reviewTabShippingOriginFacVal: ".review-tab-shipping-origin-fac-val",
  originFacilityName: ".origin-facility-name",
  reviewTabShippingOriginAddressVal: ".review-tab-shipping-origin-address-val",
  originFacilityAddress: "#origin-fac-address",

  reviewTabShippingDestinationFacVal: ".review-tab-shipping-dest-fac-val",
  destinationFacilityName: ".destination-facility-name",
  reviewTabShippingDestinationAddressVal: ".review-tab-shipping-dest-address-val",
  destinationFacilityAddress: "#dest-fac-address",

  reviewTabPhoneNumberVal: ".review-tab-phone-number-val",
  contactPhoneInput: ".cad-contact-phone-input",


  reviewTabShippingFromAddressVal: ".review-tab-shipping-from-address-val",

  countrySelect: ".cad-country-select",
  address1Input: ".cad-address-1-input",
  address2Input: ".cad-address-2-input",
  cityInput: ".cad-city-input",
  stateSelect: ".cad-state-select",
  stateTextInput: ".cad-state-text-input",
  zipInput: ".cad-zip-input",

  reviewTabShippingToVal: ".review-tab-shipping-to-val",
  shippingToSelect: ".shipping-to-select",

  // reviewTabShippingToAddressVal: ".review-tab-shipping-to-address-val"

  shippingReviewEntryPoint: ".shipping-review-entry-point",
  printPackingSlipDiv: ".print-packing-slip-div",
};

const widgetElementsMap = {
  palletCasesSection: ".pallet-cases-section",
  parcelCasesSection: ".parcel-cases-section",
  servicesEntryPoint: ".review-tab-services-entry-point"
};

export default function ReviewTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const reviewTabElement = wizardElement.find(".review-tab");
  const defaultCarriers = wizardElement.data('default-carrier');
  const els = {};
  //let palletShippingView;
  //let parcelShippingView;
  let packingReviewView;
  let servicesTabView;
  let shippingReviewView;

  self.init = function(){
    setElements();
    bindElements();
    initWidgets();
    //bindStores();
  };

  self.didNavigateToForm = function(){
    fillElementsWithVals();
    initWidgets();
    printPackinglabelchange();
  };

/*  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", toggleCasePalletSubviewsViews);
    AsnDetailStore.bindListener("asn_details:add", toggleCasePalletSubviewsViews);
    AsnDetailStore.bindListener("asn_details:remove", toggleCasePalletSubviewsViews);
  }
*/



  function bindElements(){
    els.sectionTitlesReviewTab.bind('click', function(){
      const form = wizardElement.find($(this).data("target-form"));
      wizard.gotToForm(form);
    });
  }

  function initWidgets(){
    const readOnly = true;

    packingReviewView = new PackingReviewView(wizard);
    packingReviewView.init();

    // Services Tab Component

    servicesTabView = new ServicesTab(wizard, {scopeElement: els.servicesEntryPoint, readOnly});
    servicesTabView.init();

    // Shipping Review Component
    shippingReviewView = new ShippingReviewView(null, {
      getAsn,
      getAsnDetailGroups: getOrganizedAsnDetails,
      getSelectedQuoteForAsn,
      hasShippingPartner,
      isInboundCarrierOther,
      isPallet,
      getAsnShipppingPallets
    });
    shippingReviewView.init();
    els.shippingReviewEntryPoint.html(shippingReviewView.getElement());
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
    setElementsFromScope(els, widgetElementsMap, reviewTabElement);
  }

  function fillElementsWithVals(){

    fillLocationsArea();
  }

  function fillLocationsArea(){

    //els.reviewTabShippingFromVal.text(els.locationNameInput.val());
    //els.reviewTabContactNameVal.text(els.contactNameInput.val());
    //els.reviewTabPhoneNumberVal.text(els.contactPhoneInput.val());

    //const fromAddress = formatFromAddress();
    //els.reviewTabShippingFromAddressVal.text(fromAddress);

    //els.reviewTabShippingToVal.text(els.shippingToSelect.find(":selected").text());

    els.reviewTabShippingOriginFacVal.text(els.originFacilityName.find(":selected").text());
    els.reviewTabShippingOriginAddressVal.html(els.originFacilityAddress.html());
    els.reviewTabShippingDestinationFacVal.text(els.destinationFacilityName.find(":selected").text());
    els.reviewTabShippingDestinationAddressVal.html(els.destinationFacilityAddress.html());



    // els.orderReferenceNumberReviewTab.html(els.orderReferenceNumber.val());
    // els.shippingTypeReviewTab.html(selectVal(els.shippingTypeSelect));
    // els.customerEmailReviewTab.html(els.customerEmail.val());
    // els.sendTrackingInfoReviewTab.html(trackingInfoBoolToHtml());
    // els.addressReviewTab.html(addressFormatted());

    // const showable = combineElements([
    //   els.shippingTypeOuterReviewTab,
    //   els.orderReferenceNumberOuterReviewTab,
    //   els.customerEmailOuterReviewTab,
    //   els.sendTrackingInfoOuterReviewTab,
    //   els.addressOuterReviewTab
    // ]);
    // show(showable);
  }
  function printPackinglabelchange(){
    if((getAsn().printPackingSlipFlag)){
      els.printPackingSlipDiv.html("<span class='q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg'>Yes</span>")
    }else{
     els.printPackingSlipDiv.html("<span class='q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg'>No</span>")
    } 
  }

/*  function formatFromAddress(){
    return formatAddress({
      address1: els.address1Input.val(),
      address2: els.address2Input.val(),
      city: els.cityInput.val(),
      state: getState(),
      zip: els.zipInput.val(),
      country: els.countrySelect.find(":selected").text()
    });
  }
*/
  function getState(){
    let state = els.stateSelect.val();
    if(!state || state === "-1"){
      state = els.stateTextInput.val();
    }
    return state;
  }


 /* function toggleCasePalletSubviewsViews(){
    if(isParcel()){
      showParcelRelatedViews();
    }
    else if(isPallet()){
      showPalletRelatedViews();
    }
  }

  function showParcelRelatedViews(){
    hide(els.palletCasesSection);
    let asn = AsnStore.getOrCreateAsnWithShippingMethod("parcel");

    if(AsnStore.getAsnDetails(asn).length){
      show(els.parcelCasesSection);
    }
    else{
      hide(els.parcelCasesSection);
    }
  }


  function showPalletRelatedViews(){
    hide(els.parcelCasesSection);
    let asn = AsnStore.getOrCreateAsnWithShippingMethod("pallet");

    if(AsnStore.getAsnDetails(asn).length){
      show(els.palletCasesSection);
    }
    else{
      hide(els.palletCasesSection);
    }
  }
*/
  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

/*  function getAsnId(){
    return getAsn().id;
  }
*/

  function getAsnDetails(){
    return AsnStore.getAsnDetails(getAsn());
  }

  function getAsnShippingPallet(){
    return AsnStore.getAsnShippingPallet(getAsn());
  }

  function hasShippingPartner(){
    return AsnStore.hasShippingPartner(getAsn());
  }

  // store function wrappers
  function getShippingMethod(){
    return AsnStore.getShippingMethod();
  }

  function getSelectedQuoteForAsn(){
    return AsnStore.getSelectedQuoteForAsn(getAsn());
  }

  function isInboundCarrierOther(){
    let inboundCarrierVal = getAsn().inboundCarrier;
    if (inboundCarrierVal !== null) {
      for (let keyValue in defaultCarriers) {
        if (inboundCarrierVal === defaultCarriers[keyValue].cdmValue) {
          return false;
        } else if (inboundCarrierVal === "Other") {
          return true;
        }
      }
      return true;
    }
  }

/*  function isParcel(){
    return getShippingMethod() === 'parcel';
  }
  */
  function isPallet(){
    return getShippingMethod() === 'pallet';
  }

  function getOrganizedAsnDetails(){
    if(isPallet()){
      return AsnDetailStore.organizeIntoPallets(getAsnDetails());
    }else{
      return AsnDetailStore.organizeIntoCases(getAsnDetails());
    }
  }

  function getAsnShipppingPallets(){
    return AsnStore.getAsnShipppingPallets(getAsn());
  }


}



// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/ReviewTab.js